import type { ComponentSchema } from "../../../../../schema-types"
import { SUPPORTED_PAGES, LINK_ITEM_SCHEMA, MEGA_MENU_SCHEMA } from '../../_builder-constants'

export const schema: ComponentSchema = {
  type: "header",
  label: "Header",
  description: "Site-wide header with navigation, search, and cart.",
  supportedPages: [...SUPPORTED_PAGES],
  variants: [
    { id: "v1", label: "Fashion (Default)" },
    { id: "v2", label: "Electronics" },
    { id: "v3", label: "Beauty / Minimal" },
    { id: "v4", label: "Jewelry / Elegant" },
  ],
  commonFields: [
    { key: "logo.alt", label: "Logo Alt Text", type: "string" },
    { key: "logo.src", label: "Logo Image", type: "image" },
    { key: "sticky", label: "Sticky Header", type: "boolean", default: true },
    {
      key: "topbar",
      label: "Top Bar",
      type: "object",
      fields: [
        { key: "active", label: "Enable Top Bar", type: "boolean", default: true },
        {
          key: "variant",
          label: "Variant",
          type: "select",
          options: [
            { label: "V1 (Centered Promo)", value: "v1" },
            { label: "V2 (Contact & Socials)", value: "v2" },
          ],
          default: "v1",
        },
        { key: "text", label: "Announcement Text", type: "string" },
        { key: "phone", label: "Phone Number", type: "string" },
        { key: "email", label: "Email Address", type: "string" },
        { key: "showSocials", label: "Show Social Icons", type: "boolean", default: true },
        {
          key: "socialLinks",
          label: "Social Links",
          type: "array",
          itemSchema: [
            { key: "platform", label: "Platform", type: "string" },
            { key: "href", label: "Link", type: "string" },
            { key: "icon", label: "Icon Name", type: "string" },
          ],
        },
        { key: "links", label: "Top Bar Links", type: "array", itemSchema: LINK_ITEM_SCHEMA },
      ],
    },
    {
      key: "actions",
      label: "Actions",
      type: "object",
      fields: [
        { key: "showSearch", label: "Show Search", type: "boolean", default: true },
        { key: "showCart", label: "Show Cart", type: "boolean", default: true },
        { key: "showAccount", label: "Show Account", type: "boolean", default: true },
        { key: "showWishlist", label: "Show Wishlist", type: "boolean", default: true },
        {
          key: "cartAction",
          label: "Cart Action",
          type: "select",
          options: [
            { label: "Slide-out Sidebar", value: "sidebar" },
            { label: "Go to Page", value: "page" },
          ],
          default: "sidebar",
        },
      ],
    },
    {
      key: "searchConfig",
      label: "Search Settings",
      type: "object",
      fields: [
        { key: "showPrice", label: "Show Price in Suggestions", type: "boolean", default: true },
        { key: "showCategory", label: "Show Category in Suggestions", type: "boolean", default: true },
        { key: "showImage", label: "Show Image in Suggestions", type: "boolean", default: true },
        { key: "maxResults", label: "Max Suggestions", type: "number", default: 6 },
      ],
    },
    { key: "menu", label: "Main Menu", type: "array", itemSchema: MEGA_MENU_SCHEMA },
  ],
}
